import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { DeleteIcon, EditAltIcon, MenuVerticalIcon } from 'cokitchen-icons';
import React, { useState } from 'react';

export type KeywordType = {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  type: string;
  popular: boolean;
};
const MetadataKeyword = ({
  keyword,
  onEditClick,
  onDeleteClick
}: {
  keyword: KeywordType;
  onDeleteClick: () => void;
  onEditClick: () => void;
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className='flex justify-between m-[14px] items-center w-full  max:w-[260px] rounded-r-1 rounded-l-1 rounded-b-1 relative shadow-lg px-4'>
      <p className='text-sm'>{keyword.name}</p>
      <Dropdown
        visible={showDropdown}
        content={
          <button onClick={() => setShowDropdown(!showDropdown)} className='py-6 '>
            <MenuVerticalIcon />
          </button>
        }
        onClickOutside={() => setShowDropdown(false)}
        className='min-w-[199px]'>
        <DropdownList>
          <DropdownItem onClick={onEditClick} className='min-h-[38px]'>
            <div className='flex items-center gap-3 text-sm '>
              <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                <EditAltIcon />
              </div>
              <p> Edit Keyword</p>
            </div>
          </DropdownItem>
          <DropdownItem
            className='min-h-[38px]'
            onClick={() => {
              onDeleteClick();
            }}>
            <div className='flex gap-3 items-center text-sm'>
              <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                <DeleteIcon />
              </div>
              <p> Delete Keyword</p>
            </div>
          </DropdownItem>
        </DropdownList>
      </Dropdown>
      {keyword.popular && (
        <div
          style={{ borderRadius: '0 4px 0px 4px' }}
          className='bg-[#46AE31] absolute top-0 right-0  text-white text-[10px] rounded-full w-fit px-2 py-[2px]  '>
          <p> Popular</p>
        </div>
      )}
    </div>
  );
};

export default MetadataKeyword;
